import React from 'react';

import { TEventWeather } from '@entities/eventJournal/model/types';
import { Flex, Image, UiText } from '@shared/ui';

import cls from './WeatherBlock.module.css';

interface IWeatherBlockProps {
    temperature: TEventWeather['temperature'];
    iconUrl: TEventWeather['iconImageUrl'];
}
export const WeatherBlock = ({ temperature, iconUrl }: IWeatherBlockProps) => (
    <Flex>
        <UiText weight="medium" className={cls.WeatherTemperature}>
            {temperature}°
        </UiText>
        <Image src={iconUrl} width={28} height={28} />
    </Flex>
);
